module.exports = __webpack_public_path__ + "static/media/29ADMSPC31.0a063e67.jpg";